/* eslint-disable max-len */

export const CloseCircleIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_18050_153428"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_18050_153428)">
        <circle cx="10" cy="9.99988" r="7" fill="white" />
        <path
          d="M10 11.0625L12.4167 13.4792C12.5694 13.6319 12.7465 13.7049 12.9479 13.6979C13.1493 13.691 13.3264 13.6111 13.4792 13.4583C13.6319 13.3056 13.7083 13.1285 13.7083 12.9271C13.7083 12.7257 13.6319 12.5489 13.4792 12.3967L11.0625 9.98958L13.4792 7.58244C13.6319 7.43026 13.7083 7.25347 13.7083 7.05208C13.7083 6.85069 13.6319 6.67361 13.4792 6.52083C13.3264 6.36806 13.1493 6.29167 12.9479 6.29167C12.7465 6.29167 12.5694 6.36806 12.4167 6.52083L10 8.9375L7.58333 6.52083C7.43056 6.36806 7.25694 6.29167 7.0625 6.29167C6.86806 6.29167 6.69444 6.36806 6.54167 6.52083C6.38889 6.67361 6.3125 6.85069 6.3125 7.05208C6.3125 7.25347 6.38828 7.43056 6.53985 7.58333L8.9375 10L6.52083 12.4167C6.36806 12.5694 6.29514 12.7431 6.30208 12.9375C6.30903 13.1319 6.38889 13.3056 6.54167 13.4583C6.69444 13.6111 6.87153 13.6875 7.07292 13.6875C7.27431 13.6875 7.45078 13.6117 7.60235 13.4601L10 11.0625ZM10.0058 18C8.9047 18 7.86806 17.7917 6.89583 17.375C5.92361 16.9583 5.07292 16.3854 4.34375 15.6562C3.61458 14.9271 3.04167 14.0767 2.625 13.105C2.20833 12.1334 2 11.0952 2 9.99046C2 8.88571 2.20833 7.85069 2.625 6.88542C3.04167 5.92014 3.61458 5.07292 4.34375 4.34375C5.07292 3.61458 5.92332 3.04167 6.89496 2.625C7.86661 2.20833 8.90481 2 10.0095 2C11.1143 2 12.1493 2.20833 13.1146 2.625C14.0799 3.04167 14.9271 3.61458 15.6562 4.34375C16.3854 5.07292 16.9583 5.92169 17.375 6.89008C17.7917 7.85849 18 8.89321 18 9.99425C18 11.0953 17.7917 12.1319 17.375 13.1042C16.9583 14.0764 16.3854 14.9271 15.6562 15.6562C14.9271 16.3854 14.0783 16.9583 13.1099 17.375C12.1415 17.7917 11.1068 18 10.0058 18Z"
          fill="#9CA3AF"
        />
      </g>
    </svg>
  );
};
